import { createI18n } from 'vue-i18n'
import vi from './locales/vi.json'
import en from './locales/en.json'

const STORAGE_KEY = 'locale'

// Default is Vietnamese; English only when the user explicitly chose it.
function detectDefault() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'vi' || stored === 'en') return stored
  } catch { /* storage unavailable */ }
  return 'vi'
}

const isObj = (v) => v && typeof v === 'object' && !Array.isArray(v)

/** Deep merge `src` into `dst` (src wins on conflicts). */
function deepMerge(dst, src) {
  for (const k of Object.keys(src || {})) {
    if (isObj(src[k]) && isObj(dst[k])) deepMerge(dst[k], src[k])
    else dst[k] = src[k]
  }
  return dst
}

// Overlays: src/i18n/locales/overlays/vi.<name>.json and en.<name>.json are
// merged automatically (alphabetical by file name), so feature packages add
// strings without touching vi.json / en.json.
const overlayFiles = import.meta.glob('./locales/overlays/*.json', { eager: true })
function buildMessages(lang, base) {
  const out = JSON.parse(JSON.stringify(base))
  const prefix = `./locales/overlays/${lang}.`
  Object.keys(overlayFiles).sort().forEach((p) => {
    if (p.startsWith(prefix)) deepMerge(out, overlayFiles[p].default || overlayFiles[p])
  })
  return out
}

export const i18n = createI18n({
  legacy: false, // composition API mode — use useI18n() in components
  locale: detectDefault(),
  fallbackLocale: 'vi',
  messages: { vi: buildMessages('vi', vi), en: buildMessages('en', en) }
})

/** Switches the active language and persists the choice (mirrors useDarkMode). */
export function setLocale(locale) {
  i18n.global.locale.value = locale
  try { localStorage.setItem(STORAGE_KEY, locale) } catch { /* ignore */ }
  document.documentElement.setAttribute('lang', locale)
}

document.documentElement.setAttribute('lang', i18n.global.locale.value)
